import service from "@/utils/request";

// 获取文档配置列表
export function getDocumentConfigList(data) {
    return service({
        url: "/platformConfig/queryPage",
        method: "post",
        data,
    });
}

// 获取文档配置详情
export function getDocumentConfigDetail(params) {
    return service({
        url: "/platformConfig/getById",
        method: "get",
        params,
    });
}

// 更新文档配置
export function updateDocumentConfig(data) {
    return service({
        url: "/platformConfig/update",
        method: "post",
        data,
    });
}

// 删除文档配置
export function deleteDocumentConfig(params) {
    return service({
        url: "/platformConfig/delete",
        method: "get",
        params,
    });
}

// 新增文档配置
export function createDocumentConfig(data) {
    return service({
        url: "/platformConfig/save",
        method: "post",
        data,
    });
}

// 更新文档状态
export function updateDocumentConfigStatus(params) {
    return service({
        url: "/platformConfig/updateEnable",
        method: "get",
        params,
    });
}

export function getByConfigKey(params) {
    return service({
        url: "/platformConfig/getByConfigKey",
        method: "get",
        params,
    });
}
